// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609152034/js/" + chunkId + "." + {"44":"1e8bf3f2","225":"3cb1111c","481":"8d8a3760","486":"818ff98a","770":"9e919cb3"}[chunkId] + ".0.644051293339191.chunk.js";
};